import React from "react";
import { TextField, Box, FormControl } from "@mui/material";
import { useField } from "formik";
import isEmpty from "lodash/isEmpty";
import ImageInput from "src/components/form/ImageInput";

const ScanFileInput = ({ disabled, name, onUpload, label, filestack }) => {
  const [field, _meta, helpers] = useField(name);

  const onUploadField = (fileUrl, { onSuccess, onFailure }) => {
    return onUpload(fileUrl, {
      onSuccess: () => {
        helpers.setValue(fileUrl);
        onSuccess();
      },
      onFailure,
    });
  };

  return (
    <ImageInput
      {...field}
      filestack={filestack}
      name={name}
      disabled={disabled}
      label={label}
      imageUrl={isEmpty(field.value) ? null : field.value}
      onUpload={onUploadField}
    />
  );
};

const styles = {
  textField: {
    "& input": {
      textTransform: "uppercase",
    },
  },
};

const ScanInput = ({ imageName, onUpload, name, label, disabled, filestack = false, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const error = meta.touched && meta.error;

  if (!meta.touched && !field.value && props.value) {
    helpers.setValue(props.value);
  }

  return (
    <>
      <FormControl fullWidth>
        <TextField
          {...props}
          {...field}
          label={label}
          error={!!error}
          helperText={error}
          variant="outlined"
          margin="none"
          sx={styles.textField}
          disabled={disabled}
          onChange={event => helpers.setValue(event.target.value)}
          value={field.value || ""}
        />
      </FormControl>

      <Box mt={1} mb={2}>
        {imageName && onUpload && (
          <ScanFileInput
            filestack={filestack}
            name={imageName}
            label={`Upload ${label}`}
            disabled={disabled}
            onUpload={onUpload}
          />
        )}
      </Box>
    </>
  );
};

export default React.memo(ScanInput);
